<template>
  <div
    class="p-5 border-b-4 border-tertiary flex-grow text-sm"
    :class="labelClass"
  >
    <span v-html="label"></span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    step: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  mixins: [],
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    parentStep() {
      return this.$parent.$parent.currentStep; // FIXME : UGLY
    },
    isPrevious() {
      return this.parentStep > this.step;
    },
    isCurrent() {
      return this.parentStep === this.step;
    },
    isNext() {
      return this.parentStep < this.step;
    },

    labelClass() {
      if (this.isPrevious) {
        return "font-bold border-primary text-gray-700";
      }

      if (this.isCurrent) {
        return "font-bold border-action text-black";
      }

      if (this.isNext) {
        return "border-gray-300 text-gray-700";
      }
      return "";
    },
  },
  mounted() {},
};
</script>

<style></style>
